import PopupWindow from './PopupWindow';

export default PopupWindow;